import { IRootState } from '../../../../../store'
import { IDrainsAndTubesState } from '../store/drainsAndTubes.types'

export const getDrainsAndTubesSelector = (state: IRootState): IDrainsAndTubesState => state.drainsAndTubes
